import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";

class EndEventState extends BaseState<StateManager> {
  public id = "EndEventState"; // A unique identifier for the state
  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager;
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredEndEventState();

    setTimeout(() => {
      if (this.stateManager) {
        this.stateManager.changeState(stateManager.preEventGameState);
      }
    }, 5000);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { EndEventState };
